// extracted by mini-css-extract-plugin
module.exports = {"cursor":"style_cursor_3a7Zr","regularText":"style_regularText_2vMyN"};